import { render, staticRenderFns } from "./ProofForm.vue?vue&type=template&id=db16d3ec&"
import script from "./ProofForm.vue?vue&type=script&lang=js&"
export * from "./ProofForm.vue?vue&type=script&lang=js&"
import style0 from "./ProofForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports